import { createContext } from 'react';

import { initialState } from './reducer.ts';
import { type DispatchType, type State } from './types.ts';

const GetHelpContext = createContext<{
    dispatch: DispatchType;
    state: State;
}>({ dispatch: () => {}, state: initialState });

export default GetHelpContext;
